import type { QueryHookOptions } from "@apollo/client"
import { useQuery } from "@apollo/client"
import query from "@/v2-backoffice-client/tenant/privacy/tenant.privacy.catalog.query.gql"
import type {
  TenantPrivacyCatalogQuery,
  TenantPrivacyCatalogQueryVariables,
} from "@/v2-backoffice-client/tenant/privacy/__types__/tenant.privacy.catalog.query"

type Options = QueryHookOptions<
  TenantPrivacyCatalogQuery,
  TenantPrivacyCatalogQueryVariables
>

export function useTenantPrivacyCatalogQuery(options?: Options) {
  return useQuery<
    TenantPrivacyCatalogQuery,
    TenantPrivacyCatalogQueryVariables
  >(query, options)
}
